import { useState } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import GameList from "../../components/GameList";
import CyberpunkDashboard from "./components/CyberpunkDashboard";
import Swal from "sweetalert2";
import styles from './style.module.css';


const HomePage = () => {
  const [isShowLogout, setIsShowLogout] = useState(false);

  const openDialog = () => {
    Swal.fire({
      title: `TIỂU SỬ`,
      html: `Kể từ năm 2021, Richard Branson đã cố gắng phá vỡ các kỷ lục thế giới. Ban đầu anh ấy muốn có được chiếc cúp Hales Trophy (giải thưởng người đầu tiên sáng tạo ra bộ công thức tính xác xuất số học Bacarat đầu tiên ).
<br>
            Mặc dù đã được biết đến rộng rãi hiện nay, nhưng tỷ phú đô la không được coi trọng ở trường. "Tôi từng được xem là học sinh kém nhất ở trường. Lúc ấy, suy nghĩ sau này sẽ thành công đã không xuất hiện trong tâm trí tôi",
<br>
            Trong giới tỷ phú thế giới, ít có nhân vật nào chịu chơi và mạo hiểm như Richard Branson tự sáng tạo ra các công thức số học về Bacarat .Ở tuổi 71, nhiều người đã lựa chọn ở nhà quây quần cùng con cháu, trong khi vị tỷ phú này vẫn miệt mài nghiên cứu sáng tạo ra các công thức số học mới cho dù có trong tay khối tài sản hơn 5 tỷ USD, đến nay vẫn chưa có dấu hiệu muốn dừng lại và nghỉ ngơi.
<br>
            Richard Branson  Tổng tài sản trị giá hàng tỷ đô rõ ràng đã làm nhiều công thức BACARAT rất chuẩn xác và đặc biệt thành công trong nhiều năm qua.
<br>
            Richard Branson được nhiều ngưỡng mộ bởi sự kiên cường của ông, bởi những thương hiệu cá nhân mà ông định hình và phát triển điển hình như thương hiệu Công Thức BaCaRat LV9`,
      customClass: {
        popup: styles.customSweetAlert,
        title: styles.customSweetAlertTitle,
        htmlContainer: styles.customSweetAlertContent
      },
      showClass: {
        popup: `animate__animated animate__fadeInUp animate__faster`
      },
      hideClass: {
        popup: `animate__animated animate__fadeOutDown animate__faster`
      }
    });
  }

  return (
    <div>
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <GameList />
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 1
      }}>
        <div style={{
          position: 'absolute',
          top: 70,
          left: 0,
          width: '200px',
          height: '200px',
          pointerEvents: 'auto'
        }}>
          <CyberpunkDashboard />
        </div>
        <div style={{
          position: 'absolute',
          top: 85,
          right: 0,
          padding: '15px',
          width: '150px',
          height: '100px',
          overflow: 'auto',
          pointerEvents: 'auto'
        }}>
          <button onClick={() => openDialog()} type="button" style={{ background: '#4e8b45', color: 'white', borderRadius: '5px', padding: '10px 20px', marginBottom: '10px' }}>TIỂU SỬ</button>
        </div>
        <div style={{
          position: 'absolute',
          bottom: 90,
          left: 0,
          width: '200px',
          height: '200px',
          pointerEvents: 'auto'
        }}>
          <CyberpunkDashboard />
        </div>
        <div style={{
          position: 'absolute',
          bottom: 90,
          right: 250,
          width: '200px',
          height: '200px',
          pointerEvents: 'auto'
        }}>
          <CyberpunkDashboard />
        </div>
      </div>
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </div>
  );
};

export default HomePage;
